import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5fff3ca4"
import script from "./Footer.js?vue&type=script&lang=js&external"
export * from "./Footer.js?vue&type=script&lang=js&external"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5fff3ca4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fff3ca4')) {
      api.createRecord('5fff3ca4', component.options)
    } else {
      api.reload('5fff3ca4', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=5fff3ca4", function () {
      api.rerender('5fff3ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/footer/Footer.vue"
export default component.exports